import { createUseStore } from "@/hooks/useStore";

const [useConfig, setConfig] = createUseStore<any>({});

export { useConfig, setConfig };
